// extracted by mini-css-extract-plugin
export var details = "_go-0";
export var inspectorPopover = "_go-1";